import { render, staticRenderFns } from "./PaymentStatusGopay.vue?vue&type=template&id=330ba01e"
import script from "./PaymentStatusGopay.vue?vue&type=script&lang=js"
export * from "./PaymentStatusGopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports